import type { AcriAnswer } from '@/components/OnboardingQuestionPage'
import OnboardingQuestionPage from '@/components/OnboardingQuestionPage'

const answers: AcriAnswer[] = [
  {
    title: 'pages.onboarding.aiImpact.none',
    subtitle: 'pages.onboarding.aiImpact.noneSub',
    value: 'none',
  },
  {
    title: 'pages.onboarding.aiImpact.talking',
    subtitle: 'pages.onboarding.aiImpact.talkingSub',
    value: 'talking',
  },
  {
    title: 'pages.onboarding.aiImpact.experimenting',
    subtitle: 'pages.onboarding.aiImpact.experimentingSub',
    value: 'experimenting',
  },
  {
    title: 'pages.onboarding.aiImpact.implementing',
    subtitle: 'pages.onboarding.aiImpact.implementingSub',
    value: 'implementing',
  },
  {
    title: 'pages.onboarding.aiImpact.aiFirst',
    subtitle: 'pages.onboarding.aiImpact.aiFirstSub',
    value: 'ai-first',
  },
]

export default function AiImpactPage() {
  return (
    <OnboardingQuestionPage
      answers={answers}
      title="pages.onboarding.aiImpact.title"
      subtitle="pages.onboarding.aiImpact.subtitle"
    />
  )
}
